/**
 * Sports API helpers — thin wrappers around /api/sports/*.
 *
 * iter-85 · Sports Mode v0 ships static curated quote banks per game.
 * Live event polling layered on top via `getGameEvents`.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function listSportsGames() {
    const { data } = await axios.get(`${API}/sports/games`);
    return data?.games || [];
}

export async function getSportsGame(slug) {
    const { data } = await axios.get(`${API}/sports/games/${encodeURIComponent(slug)}`);
    return data;
}

export async function getSportsCards(slug, { side, tone, moment_type, limit = 12 } = {}) {
    const params = new URLSearchParams();
    if (side) params.set("side", side);
    if (tone) params.set("tone", tone);
    if (moment_type) params.set("moment_type", moment_type);
    if (limit) params.set("limit", String(limit));
    const qs = params.toString();
    const { data } = await axios.get(
        `${API}/sports/games/${encodeURIComponent(slug)}/cards${qs ? `?${qs}` : ""}`,
    );
    return data?.items || [];
}

export async function getGameEvents(slug, since = null) {
    const params = new URLSearchParams();
    if (since) params.set("since", since);
    const qs = params.toString();
    const { data } = await axios.get(
        `${API}/sports/games/${encodeURIComponent(slug)}/events${qs ? `?${qs}` : ""}`,
    );
    return data?.items || [];
}
